import { render, staticRenderFns } from "./DriverPerformance.vue?vue&type=template&id=5ba007fa&scoped=true&"
import script from "./DriverPerformance.vue?vue&type=script&lang=js&"
export * from "./DriverPerformance.vue?vue&type=script&lang=js&"
import style0 from "./DriverPerformance.vue?vue&type=style&index=0&id=5ba007fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba007fa",
  null
  
)

export default component.exports